import { createContext } from 'react';

import { Pergunta, ListaPerguntas } from 'api/DuvidasFrequentes';

interface DuvidasFrequentesContext {
  perguntas: ListaPerguntas | null;
  atualizarPergunta: (changes: Pergunta) => void;
  isPerguntaAdmin: (pergunta: Pergunta) => boolean;
  isPerguntaUsuario: (pergunta: Pergunta) => boolean;
  isPerguntaNaoLida: (pergunta: Pergunta) => boolean;
  ocultarNomeChat: boolean;
  cpf: string;
  cooperativa: string;
  destaque: number | string | null;
  setDestaque: (id: number | string | null, marcarComoLido: boolean) => void;
}

export default createContext<DuvidasFrequentesContext>({
  perguntas: null,
  atualizarPergunta: () => {},
  isPerguntaAdmin: () => false,
  isPerguntaUsuario: () => false,
  isPerguntaNaoLida: () => false,
  ocultarNomeChat: false,
  cpf: '',
  cooperativa: '',
  destaque: null,
  setDestaque: () => {},
});
